import { useQuery } from "@tanstack/react-query";

import { getOrder } from "../../../shared/api";

type UseOrderParams = {
  onlineOrderId?: string;
  refetchInterval?: number | false;
};

export const useOrder = ({ onlineOrderId, refetchInterval }: UseOrderParams) =>
  useQuery({
    queryFn: () => getOrder(onlineOrderId),
    queryKey: ["order"],
    enabled: Boolean(onlineOrderId),
    refetchInterval,
  });
